import { resolve } from '../api/request';
import constants from '../app/constants';

export function resolveRequest(context, { request, dispatchEnd = true }) {
    return context
        .executeAction(requestStart, request.requestKey)
        .then(() => resolve(request))
        .then(resolved => {
            if (dispatchEnd) {
                context.executeAction(requestEnd, request.requestKey);
                return resolved;
            } else {
                return resolved;
            }
        });
}

export function requestStart(context, key) {
    return Promise.resolve(key).then(() => {
        context.dispatch(constants.API_REQUEST_START, key);
    });
}

export function requestEnd(context, key) {
    return Promise.resolve(key).then(() => {
        context.dispatch(constants.API_REQUEST_END, key);
    });
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/actions/request.js